module.exports = __webpack_public_path__ + "img/36627-048.67ff26e7.jpg";